import { Box } from '@mui/material'

import PassesTable from '/components/passes/passes-table'

const TemplatePassesTable = ({ templateId, deletedPassIds, onSelectTemplate, onSelectedPassesChange, onSelectedPassChange, onRowDoubleClick, onPassIdClick }) => (
  <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
    <Box sx={{ flex: 1, minHeight: 0 }}>
      <PassesTable key={templateId} templateId={templateId} deletedPassIds={deletedPassIds} onSelectTemplate={onSelectTemplate} onSelectedPassesChange={onSelectedPassesChange} onSelectedPassChange={onSelectedPassChange} onRowDoubleClick={onRowDoubleClick} onPassIdClick={onPassIdClick} />
    </Box>
  </Box>
)

export default TemplatePassesTable
